document.addEventListener('DOMContentLoaded', () => {
  new Swipix({
    container: '.skin-care-carousel',
    infiniteLoop: true,
    autoplay: {
      enabled: true,
      delay: 5000,
      pauseOnInteraction: true,
      pauseAfterInteraction: false,
    },
    gap: 20,
    slidesPerView: {
      default: 1,
      768: 2,
      1024: 3,
    },
    nextButton: '.next-btn',
    prevButton: '.prev-btn',
  }).init();

  document.querySelectorAll('.skin-video-facade').forEach((facade) => {
    facade.addEventListener('click', () => {
      if (facade.classList.contains('is-loading')) return;

      const template = facade.querySelector('template');
      const wrapper = facade.closest('.skin-video-wrapper');
      const iframe = template.content.cloneNode(true).querySelector('iframe');

      facade.classList.add('is-loading');

      iframe.addEventListener('load', () => {
        iframe.classList.add('is-ready');
        facade.remove();
      });

      wrapper.appendChild(iframe);
    });
  });
});
